import React from "react";
import { render } from "react-dom";
import localforage from "localforage";
import * as mobx from "mobx";
import Application from "./Application";

import "./assets/css/index.css";
import { Provider } from "mobx-react";
import { applicationContext } from "./services/main/ApplicationContext";

mobx.configure({ enforceActions: "always" });

localforage.config({
	name: "insurforce",
	storeName: "client_data_store",
});

render(
	<Provider context={applicationContext}>
		<Application />
	</Provider>,
	document.getElementById("root")
);
